import type { PerfilStatus, Pessoa, PlayerFields } from 'types/pessoa';
import { playerFieldsParaPessoa } from 'utils/player-fields';
import { api } from './api';
import { dedupedFetch } from './cache';

export const PESSOA_ME_CACHE_KEY = 'player-fields-me';

/**
 * Documento do usuário logado em `player_fields__c`. O aggregate
 * `player_fields_me` deriva o `_id` de `context.player` no servidor, então
 * nenhum `_id` sai do navegador. Devolve `null` quando a pessoa não está na base
 * e lança erro em falha de rede ou do servidor, para não confundir os dois casos.
 */
export function buscarPlayerFieldsMe(): Promise<PlayerFields | null> {
  return dedupedFetch(PESSOA_ME_CACHE_KEY, async () => {
    const { data } = await api.post('/find/player_fields_me', {});
    return Array.isArray(data) && data.length > 0 ? (data[0] as PlayerFields) : null;
  }, 60_000);
}

export interface PerfilCarregado {
  pessoa: Pessoa | null;
  /** Documento original, lido pelas telas de votação e pelo header. */
  detail: PlayerFields | null;
  perfil: PerfilStatus;
}

/** Carrega o perfil sem lançar: "fora da base" e "erro" viram status, nunca signout. */
export async function carregarPerfil(): Promise<PerfilCarregado> {
  try {
    const detail = await buscarPlayerFieldsMe();
    return {
      detail,
      pessoa: detail ? playerFieldsParaPessoa(detail) : null,
      perfil: detail ? 'ok' : 'fora_da_base',
    };
  } catch (error) {
    console.error('[carregarPerfil] falha ao buscar player_fields_me', error);
    return { detail: null, pessoa: null, perfil: 'erro' };
  }
}
